/**
 * Genera un título corto a partir de la categoría y la descripción.
 * Heurística simple: keywords → frase base + lugar si se detecta.
 */
const KEYWORDS = [
    [/agua|p[eé]rdida|filtraci[oó]n|ca[nñ]er[ií]a|gotea|humedad/i, "Pérdida de agua"],
    [/internet|wifi|red|conexi[oó]n|sin se[ñn]al/i, "Problema de internet"],
    [/luz|electricidad|enchufe|tablero|toma|corto|apag[oó]n|sin luz/i, "Problema eléctrico"],
    [/aire|fr[ií]o|calor|calefacci[oó]n|climatiz|temperatur|ventilaci[oó]n/i, "Climatización"],
    [/limpieza|sucio|sucia|basura|mancha|mugre|olor/i, "Limpieza"],
    [/puerta|cerradura|llave|trabad|cerrojo/i, "Problema con puerta"],
    [/ascensor|elevador/i, "Ascensor"],
    [/ruido|esc[aá]ndalo|gritos/i, "Ruido"],
    [/login|contrase[ñn]a|activar|notificaci[oó]n|p[uú]sh|reserv[ar]?|visita|incidencia|paquete|app|lent[ao]|no carga|no anda|no funciona|error/i, "Problema en App Foresta"],
    [/seguridad|robo|intruso|extra[ñn]o|sospechoso/i, "Seguridad"],
    [/ventana|vidrio|persiana/i, "Ventana / vidrio"],
    [/ba[ñn]o|inodoro|canilla|grifo/i, "Problema en baño"],
];

const LUGARES = /\b(cocina|ba[ñn]o|oficina|sala|pasillo|hall|recepci[oó]n|terraza|estacionamiento|cochera|patio|escalera|garage)\b/i;

const CAT_DEFAULT = {
    limpieza: "Limpieza",
    mantenimiento: "Mantenimiento",
    app_foresta: "Problema en App Foresta",
    internet: "Problema de internet",
    climatizacion: "Climatización",
    electricidad: "Problema eléctrico",
    otros: "Reclamo",
    seguridad: "Seguridad",
};

function capitalize(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

export function generarTitulo(categoria, descripcion) {
    const desc = (descripcion || "").trim();
    if (!desc) return CAT_DEFAULT[categoria] || "Reclamo";

    let base = null;
    for (const [re, title] of KEYWORDS) {
        if (re.test(desc)) { base = title; break; }
    }
    if (!base) base = CAT_DEFAULT[categoria] || "Reclamo";

    const m = desc.match(LUGARES);
    if (m) {
        const lugar = m[1].toLowerCase();
        if (!base.toLowerCase().includes(lugar)) return `${base} en ${lugar}`;
    }
    // fallback corto si todavía no hay match con keywords y no hay lugar
    if (base === CAT_DEFAULT[categoria]) {
        const words = desc.split(/\s+/).slice(0, 4).join(" ");
        if (words.length > 3) return capitalize(words);
    }
    return base;
}
